import { connect } from 'react-redux'
import { compose } from 'recompose'
import { userAttrsWithPresenceFragment } from 'remote/users'
import { dataFetched, makesSubscriptions } from 'data/graphql'
import gql from 'graphql-tag'
import * as OrganizationSelectors from 'data/organizations/selectors'

const userPresenceOnNoteUpdatedSubscription = gql`
  subscription userPresenceOnNoteUpdated($noteId: ID!) {
    userPresenceOnNoteUpdated(noteId: $noteId) {
      ...userAttrsWithPresence
    }
  }
  ${userAttrsWithPresenceFragment}
`

const providesUserPresence = ({
  mapPropsToVariables = ({ noteId }) => ({ noteId }),
} = {}) =>
  compose(
    connect(
      state => ({
        organizationId: OrganizationSelectors.getOrganizationId(state),
      }),
      {
        dataFetched,
      }
    ),
    makesSubscriptions({
      query: userPresenceOnNoteUpdatedSubscription,
      mapPropsToVariables,
      getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
        dataFetched(result.data.userPresenceOnNoteUpdated, meta)
      },
    })
  )

export default providesUserPresence
